import { Suspense, lazy, memo } from 'react'

import { TPageProps } from '~/shared/types/commonTypes'

const LearnBiology = lazy(
  () =>
    import('~/pages/onboarding/quizBinaryChoice/libs/components/LearnBiology'),
)
const PlantLife = lazy(
  () => import('~/pages/onboarding/quizBinaryChoice/libs/components/PlantLife'),
)
const AnimalWorld = lazy(
  () =>
    import('~/pages/onboarding/quizBinaryChoice/libs/components/AnimalWorld'),
)
const HumanBody = lazy(
  () => import('~/pages/onboarding/quizBinaryChoice/libs/components/HumanBody'),
)
const BiologyLevel = lazy(
  () =>
    import('~/pages/onboarding/quizBinaryChoice/libs/components/BiologyLevel'),
)
const LearningComplexity = lazy(
  () =>
    import(
      '~/pages/onboarding/quizBinaryChoice/libs/components/LearningComplexity'
    ),
)
const Skin = lazy(
  () => import('~/pages/onboarding/quizBinaryChoice/libs/components/Skin'),
)
const Octopus = lazy(
  () => import('~/pages/onboarding/quizBinaryChoice/libs/components/Octopus'),
)
const Frog = lazy(
  () => import('~/pages/onboarding/quizBinaryChoice/libs/components/Frog'),
)
const MotivatedWhileLearning = lazy(
  () =>
    import(
      '~/pages/onboarding/quizBinaryChoice/libs/components/MotivatedWhileLearning'
    ),
)
const Recommendation = lazy(
  () =>
    import(
      '~/pages/onboarding/quizBinaryChoice/libs/components/Recommendation'
    ),
)

const QuizBinaryChoiceRoot = ({ nextPagePath, pageId }: TPageProps) => (
  <Suspense fallback={null}>
    <PlantLife nextPagePath={nextPagePath} pageId={pageId} />
    <AnimalWorld nextPagePath={nextPagePath} pageId={pageId} />
    <HumanBody nextPagePath={nextPagePath} pageId={pageId} />
    <Skin nextPagePath={nextPagePath} pageId={pageId} />
    <Octopus nextPagePath={nextPagePath} pageId={pageId} />
    <Frog nextPagePath={nextPagePath} pageId={pageId} />

    {/* with no image */}
    <LearnBiology nextPagePath={nextPagePath} pageId={pageId} />
    <BiologyLevel nextPagePath={nextPagePath} pageId={pageId} />
    <LearningComplexity nextPagePath={nextPagePath} pageId={pageId} />
    <MotivatedWhileLearning nextPagePath={nextPagePath} pageId={pageId} />
    <Recommendation nextPagePath={nextPagePath} pageId={pageId} />
  </Suspense>
)

const QuizBinaryChoice = Object.assign(memo(QuizBinaryChoiceRoot), {
  LearnBiology,
  PlantLife,
  AnimalWorld,
  HumanBody,
  BiologyLevel,
  LearningComplexity,
  Skin,
  Octopus,
  Frog,
  MotivatedWhileLearning,
  Recommendation,
})

export default QuizBinaryChoice
